/** Get url for a file hosted statically */
export function getStaticFileUrl(fileName: string) {
    if (process.env.production) {
        return `/webeditor/${fileName}`;
    }

    return `/${fileName}`;
}
